module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjEyLjMxMzUiIHkxPSIxLjQxNDIxIiB4Mj0iMi40MTM5OCIgeTI9IjExLjMxMzciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxsaW5lIHgxPSIxIiB5MT0iLTEiIHgyPSIxNSIgeTI9Ii0xIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjcwNzEwNyAwLjcwNzEwNyAwLjcwNzEwNyAtMC43MDcxMDcgMi4zMTM0OCAwKSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/close.svg
// module id = EXML
// module chunks = 35